<template>
    <div>
        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Dashboard</h4>
                </div>
            </div>
        </div>
        <br><br>
        <!-- end page title -->

        <!--  dashboard statistics  -->
        <!-- <div class="row grouped-multiple-statistics-card">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon primary d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-bar-chart customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                           0
                                        </h3>
                                        <p class="sub-heading">Total Revenue</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon danger d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                           0
                                        </h3>
                                        <p class="sub-heading">Total Sales</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div class="d-flex align-items-start border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon success d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_users }}
                                        </h3>
                                        <p class="sub-heading">Users</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div class="d-flex align-items-start">
                                        <span class="card-icon warning d-flex justify-content-center mr-3">
                                            <i class="fa p-1 fa-shopping-basket customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            10
                                        </h3>
                                        <p class="sub-heading">Total Orders</p>
                                        `
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!--  end dashboard statistics  -->

        <div class="main-body">
            <div class="page-body">
                <!-- start Nav Toogle tabs -->
                <ul class="nav nav-tabs md-tabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#delivery" role="tab"
                        aria-expanded="true">Delivery Orders</a>
                        <div class="slide"></div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#pickup" role="tab" aria-expanded="false">
                        Pickup Orders
                        </a>
                        <div class="slide"></div>
                    </li>

                </ul>
                <!-- End Nav Toogle tabs -->

            </div>
        </div>


        <div class="tab-content card-block">
            <div class="tab-pane active" id="delivery" role="tabpanel" aria-expanded="true">
                <div class="row">
                    <div class="col-md-12 col-xl-12">
                        <div class="card task-sale-card">
                            <div class="card-header">
                                <div class="card-header-left">
                                    <h5>Un-Assigned or Unaccepted Orders</h5>
                                </div>
                                <div class="card-header-right">
                                    <ul class="card-controls">
                                        <!-- <li v-on:click="getOrders" title="Reload">
                                            <i class="green icofont icofont-refresh reload-card"></i>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="card-block marketing-card">
                                <div class="table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                            <th>Type</th>
                                            <th>Customer's Name</th>
                                            <th>Time</th>
                                            <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-show="orders == null"> 
                                                <td colspan="6" class="text-center" style="font-weight: bolder; ">
                                                    No orders yet
                                                </td>
                                            </tr>
                                               
                                            <tr v-for="order in unassigned_orders">
                                            <!-- <tr> -->

                                                <td v-html="formatOrderType(order.ordertype)"></td>
                                                <td>{{ order.delivery_name }}</td>
                                                <td>{{ order.orderdate.split(' ')[1] }}</td>
                                                <td>
                                                    <button class="btn btn-primary btn-mat btn-sm" data-toggle="modal" v-bind:data-target="'#order_details' + order.id">
                                                    <!-- <button class="btn btn-primary btn-mat btn-sm" data-toggle="modal" v-bind:data-target="'#order_details'"> -->
                                                        <i class="icofont icofont-eye-alt"></i>
                                                        View
                                                    </button>
                                                    <button @click.prevent="cancelOrder(order)" class="btn btn-danger btn-mat btn-sm">
                                                    <!-- <button class="btn btn-danger btn-mat btn-sm"> -->
                                                        <i class="icofont icofont-close-circled"></i>
                                                        Cancel
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                        <!-- Assigned or Accepted Orders -->
                    <div class="col-md-12 col-xl-12">
                        <div class="card summery-card">
                            <div class="card-header">
                                <div class="card-header-left ">
                                    <h5>Assigned or Accepted Orders</h5>
                                </div>
                                <div class="card-header-right">
                                    <ul class="card-controls">
                                        <!-- <li v-on:click="getOrders">
                                            <i class="green icofont icofont-refresh reload-card"></i>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="card-block marketing-card">
                                <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Customer's Name</th>
                                            <th>Time</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="order in assigned_orders">
                                            <td v-html="formatOrderType(order.ordertype)"></td>
                                            <td>{{ order.delivery_name }}</td>
                                            <td>{{ order.orderdate.split(' ')[1] }}</td>
                                            <td>
                                            <button class="btn btn-primary btn-mat btn-sm" data-toggle="modal"
                                                v-bind:data-target="'#order_details' + order.id">
                                                <i class="icofont icofont-eye-alt"></i>
                                                View
                                            </button>
                                            <button class="btn btn-success btn-mat btn-sm"
                                                v-on:click="changeStatus(order.id, 'AWAITING_PICKUP')">
                                                <i class="icofont icofont-check-circled"></i>
                                                Ready
                                            </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                        <!-- Ready Orders -->
                    <div class="col-md-12 col-xl-12">
                        <div class="card summery-card">
                            <div class="card-header">
                                <div class="card-header-left ">
                                    <h5>Ready Orders</h5>
                                </div>
                                <div class="card-header-right">
                                    <ul class="card-controls">
                                        <!-- <li v-on:click="getOrders">
                                            <i class="green icofont icofont-refresh reload-card"></i>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="card-block marketing-card">
                                <div class="table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Type</th>
                                                <th>Customer's Name</th>
                                                <th>Riders's Name</th>
                                                <th>Status</th>
                                                <th>Time</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="order in ready_orders">
                                                <td v-html="formatOrderType(order.ordertype)"></td>
                                                <td>{{ order.delivery_name }}</td>
                                                <td>{{ order.rider_name }}</td>
                                                <td>{{ order.order_status }}</td>
                                                <td>{{ order.orderdate.split(' ')[1] }}</td>
                                                <td>
                                                <button class="btn btn-primary btn-mat btn-sm" data-toggle="modal"
                                                    v-bind:data-target="'#order_details' + order.id">
                                                    <i class="icofont icofont-eye-alt"></i>
                                                    View
                                                </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                        <!-- Rejected Orders -->
                    <div class="col-md-12">
                        <div class="card task-sale-card">
                            <div class="card-header">
                                <div class="card-header-left">
                                    <h5>Rejected Orders</h5>
                                </div>
                                <div class="card-header-right">
                                    <ul class="card-controls">
                                        <!-- <li v-on:click="getRejectedOrders" title="Reload">
                                            <i class="green icofont icofont-refresh reload-card"></i>
                                        </li>
                                        <li title="Make Full Screen">
                                            <i class="red icofont icofont-maximize full-card"></i>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="card-block marketing-card">
                                <div class="table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Type</th>
                                                <th>Customer's Name</th>
                                                <th>Time</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- <tr v-for="order in rejectedorders">
                                                <td v-html="formatOrderType(order.ordertype)"></td>
                                                <td>{{ order.delivery_name }}</td>
                                                <td>{{ order.orderdate.split(' ')[1] }}</td>
                                                <td>
                                                <button class="btn btn-primary btn-mat btn-sm" data-toggle="modal"
                                                    v-bind:data-target="'#order_details' + order.id"><i
                                                    class="icofont icofont-eye-alt"></i>View</button>

                                                </td>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="tab-pane" id="pickup" role="tabpanel" aria-expanded="false">
                <div class="row">
                    <div class="col-md-12 col-xl-12">
                        <div class="card task-sale-card">
                            <div class="card-header">
                                <div class="card-header-left">
                                    <h5>New Orders</h5>
                                </div>
                                <div class="card-header-right">
                                    <ul class="card-controls">
                                        <!-- <li v-on:click="getOrders" title="Reload">
                                            <i class="green icofont icofont-refresh reload-card"></i>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="card-block marketing-card">
                                <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Customer's Name</th>
                                            <th>Time</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="order in pickup_orders">
                                            <td v-html="formatOrderType(order.ordertype)"></td>
                                            <td>{{ order.delivery_name }}</td>
                                            <td>{{ order.orderdate.split(' ')[1] }}</td>
                                            <td>
                                            <button class="btn btn-primary btn-mat btn-sm" data-toggle="modal"
                                                v-bind:data-target="'#order_details' + order.id">
                                                <i class="icofont icofont-eye-alt"></i>
                                                View
                                            </button>
                                            <button class="btn btn-success btn-mat btn-sm"
                                                v-on:click="changeStatus(order.id, 'AWAITING_PICKUP')">
                                                <i class="icofont icofont-check-circled"></i>
                                                Ready
                                            </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                        <!-- Ready Orders -->
                    <div class="col-md-12 col-xl-16">
                        <div class="card summery-card task-sale-card">
                            <div class="card-header">
                                <div class="card-header-left ">
                                    <h5>Ready Orders</h5>
                                </div>
                                <div class="card-header-right">
                                    <ul class="card-controls">
                                        <!-- <li v-on:click="getOrders">
                                            <i class="green icofont icofont-refresh reload-card"></i>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="card-block marketing-card">
                                <div class="table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Type</th>
                                                <th>Customer's Name</th>
                                                <th>Time</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="order in pickup_orders_awaiting">
                                                <td v-html="formatOrderType(order.ordertype)"></td>
                                                <td>{{ order.delivery_name }}</td>
                                                <td>{{ order.orderdate.split(' ')[1] }}</td>
                                                <td>
                                                <button class="btn btn-primary btn-mat btn-sm" data-toggle="modal"
                                                    v-bind:data-target="'#order_details' + order.id">
                                                    <i class="icofont icofont-eye-alt"></i>
                                                    View
                                                </button>
                                                <button class="btn btn-success btn-mat btn-sm"
                                                    v-on:click="changeStatus(order.id, 'COMPLETED')">
                                                    <i class="icofont icofont-check-circled"></i>
                                                    Picked Up
                                                </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            
        </div>

    </div>
</template>

<style scoped>
.task-sale-card {
  max-height: 400px;
  overflow-y: auto;
}

.line-height-2-5 {
  line-height: 2.5 !important;
}

.card-controls li {
  display: inline;
}

.green {
  color: #05ec05 !important;
}

.red {
  color: #ff0000 !important;
}

.order-table-title {
  text-decoration: underline;
}
</style>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../Shared/Mixins/PaginationMixin";
// import BarChart from "../ChartTemplate/BarChart";

export default {
    metaInfo: {title: 'Dashboard'},
    name: 'Dashboard',
    layout: Layout,
    // components: {
    //     BarChart
    // },
    props: [
        'total_users',
        'total_creators' 
    ],
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data: () => ({
        orders: null,
        rejectedorders: null,
        currentSort: 'id',
        currentSortDir: 'desc',
        unassigned_orders: [],
        assigned_orders: [],
        ready_orders: [],
        pickup_orders: [],
        pickup_orders_awaiting: [],
        riders: [],
        new_rider: "",
        sizes: [
            "Small",
            "Medium",
            "Large"
        ]
    }),
    mounted() {
        this.loaded = true
    },
    methods: {



        async cancelOrder(id) {
            this.$inertia.delete(route('admin.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },

        async showAlert(orderId) {
            const details = {
                title: "Are you sure you want to delete this product?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? this.cancelOrder(orderId) : "";
        },
    }
}
</script>
